(function () {
  function getInnerEl() {
    return document.getElementById('sticky-cart-bar-inner');
  }

  function refresh() {
    if (!window.routes || !window.routes.cart_url) return;
    fetch(`${window.routes.cart_url}?sections=sticky-cart-bar`)
      .then((response) => response.json())
      .then((data) => {
        const html = new DOMParser().parseFromString(data['sticky-cart-bar'], 'text/html');
        const source = html.getElementById('sticky-cart-bar-inner');
        const sourceWrapper = html.getElementById('sticky-cart-bar');
        const targetWrapper = document.getElementById('sticky-cart-bar');
        const target = getInnerEl();
        if (source && target && targetWrapper) {
          target.innerHTML = source.innerHTML;
          targetWrapper.classList.toggle(
            'sticky-cart-bar--hidden',
            sourceWrapper ? sourceWrapper.classList.contains('sticky-cart-bar--hidden') : false
          );
        }
      })
      .catch((e) => console.error('[sticky-cart-bar]', e));
  }

  function setDrawerOpenState(isOpen) {
    const wrapper = document.getElementById('sticky-cart-bar');
    if (wrapper) wrapper.classList.toggle('sticky-cart-bar--drawer-open', isOpen);
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-sticky-cart-bar-open]');
    if (openBtn) {
      e.preventDefault();
      const trigger = document.querySelector('.wt-cart__trigger');
      if (trigger) trigger.click();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      subscribe(PUB_SUB_EVENTS.cartDrawerOpen, function () {
        setDrawerOpenState(true);
      });
      subscribe(PUB_SUB_EVENTS.cartDrawerClose, function () {
        setDrawerOpenState(false);
      });
    }
  });
})();
